module.exports = __webpack_public_path__ + "img/60x30x72-Kit.d139dcd1.png";